<page-title [title]="title"></page-title>
<form [formGroup]="form">
  <div class="row">
    <div class="col-xs-12 col-md-3">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Cidade</mat-label>
        <mat-select>
          <mat-option *ngFor="let item of citys" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-3">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Especialidade</mat-label>
        <mat-select>
          <mat-option *ngFor="let item of specialtys" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-3">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Especialista</mat-label>
        <mat-select>
          <mat-option *ngFor="let item of practitioners" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-3 btBuscar">
      <button mat-flat-button color="primary" (click)="pesquisar()" [disabled]="loading">Buscar</button>
    </div>
  </div>
</form>
<page-scheduler></page-scheduler>
